import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { heightConverter } from "Helpers/util";
import { apiGetQuizData, apiUpdateRetakeQuizAnswer } from "Root/api/apiQuiz";
import { useEffect, useState } from "react";
import CheckboxButton from "Root/quiz/elements/checkboxElement/checkbox.element";
import RadioButton from "Root/quiz/elements/radioButton/radio";
import SliderComponent from "Root/quiz/elements/sliderComponent/slider";
import HeightAndWeightComponent from "Root/quiz/components/hardcoded/heightAndWeight/heightAndWeight";
import GoalWeight from "Root/quiz/components/hardcoded/goalWeight/goalWeight";
import toastService from "Root/profile/toastService";
export const useRetakeQuizData = () => {
    const [quizData, setQuizData] = useState([]);
    const [quizAnswers, setQuizAnswers] = useState({});
    const [freeFormValues, setFreeFormValue] = useState({});
    const [openDrawer, setOpenDrawer] = useState(false);
    const [loading, setLoading] = useState(false);
    const [notAnsweredQuestions, setNotAnsweredQuestions] = useState([]);
    const [openNotAnsweredQuestionsDrawer, setOpenNotAnsweredQuestionsDrawer] = useState(false);
    const [showAnimation, setShowAnimation] = useState(false);
    const toggleDrawer = (value) => async () => {
        setOpenDrawer(value);
        if (value) {
            setLoading(true);
            await fetchQuizData();
            setLoading(false);
        }
    };
    const toggleNotAnsweredQuestionsDrawer = (value) => async () => {
        setOpenNotAnsweredQuestionsDrawer(value);
        if (!value && notAnsweredQuestions.length) {
            const quizAnswers = JSON.parse(localStorage.getItem("answersList") || "");
            await apiUpdateRetakeQuizAnswer(quizAnswers);
            setNotAnsweredQuestions([]);
            localStorage.removeItem("answersList");
        }
    };
    const mapQuizQuestionToHumanReadable = (quizData) => {
        return quizData.map((item) => {
            let userAnswerHumanReadable = "";
            if (quizAnswers[item.questionName]) {
                userAnswerHumanReadable = item?.options
                    ?.filter((option) => quizAnswers[item.questionName]?.includes(option.value))
                    .map((item) => item.text)
                    .join(", ");
                if (item.questionType === "checkbox") {
                    let userAnswerHumanReadable = item?.options
                        ?.filter((option) => quizAnswers[item.questionName]?.includes(option.value))
                        .map((item) => item.text)
                        .join(", ");
                    return {
                        ...item,
                        userAnswerHumanReadable,
                    };
                }
                if (item.questionName === "heightAndWeight") {
                    const height = quizAnswers[item.questionName][1];
                    const weight = quizAnswers[item.questionName][0];
                    const [calculatedFeet, calculatedInches] = heightConverter("-1", height);
                    userAnswerHumanReadable = `${weight} lbs, ${calculatedFeet}'${calculatedInches}"`;
                }
                if (item.questionName === "goalWeight") {
                    userAnswerHumanReadable = `${quizAnswers[item.questionName].join(" ")} lbs`;
                }
            }
            return {
                ...item,
                userAnswerHumanReadable,
            };
        });
    };
    const fetchQuizData = async () => {
        const data = await apiGetQuizData("quiz?skip_questions=0");
        setQuizData(mapQuizQuestionToHumanReadable(data.questions.filter((item) => !!item.userAnswer)));
        Object.keys(data.quizAnswers).forEach((key) => {
            const value = data.quizAnswers[key];
            data.quizAnswers[key] = value.toString().split(",");
        });
        const answersList = Object.keys(data.quizAnswers).map((key) => {
            return {
                question: key,
                answer: data.quizAnswers[key].join(","),
                quizName: "quiz",
                free_form: freeFormValues[key] || "",
            };
        });
        localStorage.setItem("answersList", JSON.stringify(answersList));
        setQuizAnswers(data.quizAnswers);
    };
    const updateQuizData = async () => {
        if (notAnsweredQuestions.length > 0) {
            const isInvalid = notAnsweredQuestions.some((item) => {
                return !quizAnswers[item.questionName];
            });
            if (isInvalid) {
                toastService.errorMessage("Please answer all the questions");
                return;
            }
        }
        // compare two objects and return only the changed values
        const quizObj = Object.keys(quizAnswers).reduce((acc, key) => {
            const answer = Array.isArray(quizAnswers[key]) ? quizAnswers[key].join(",") : quizAnswers[key];
            if (answer !== quizData.find((item) => item.questionName === key)?.userAnswer) {
                acc[key] = answer;
            }
            return acc;
        }, {});
        const answersList = Object.keys(quizObj).map((key) => {
            return {
                question: key,
                answer: quizObj[key],
                quizName: "quiz",
                free_form: freeFormValues[key] || "",
            };
        });
        setShowAnimation(true);
        const data = await apiUpdateRetakeQuizAnswer(answersList);
        await new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, 1800);
        });
        setShowAnimation(false);
        if (data.length > 0) {
            setNotAnsweredQuestions(data);
            toggleNotAnsweredQuestionsDrawer(true)();
            toggleDrawer(false)();
        }
        else {
            toastService.successMessage("Your results updated successfully");
            if (openNotAnsweredQuestionsDrawer) {
                toggleNotAnsweredQuestionsDrawer(false)();
            }
            toggleDrawer(false)();
        }
        window.scrollTo(0, 0);
    };
    const updateQuizAnswers = (value, questionName) => {
        setQuizAnswers({ ...quizAnswers, [questionName]: value });
    };
    const updateCheckboxAnswers = (value, value2, questionName) => {
        if (Array.isArray(value)) {
            setQuizAnswers({
                ...quizAnswers,
                [questionName]: value,
            });
        }
        else if (value2) {
            setQuizAnswers({
                ...quizAnswers,
                [questionName]: value2,
            });
        }
    };
    useEffect(() => {
        if (quizData.length > 0 && Object.keys(quizAnswers).length > 0) {
            setQuizData(mapQuizQuestionToHumanReadable(quizData));
        }
    }, [quizAnswers]);
    const getUIElement = (question) => {
        const checkIfSelectedValueIsDeselectOther = (value) => {
            // Checks if the value selected is a "deselect others" value
            let deselect = false;
            if (Array.isArray(value)) {
                if (value.length === 1) {
                    const value_str = value[0];
                    question.options.forEach((option) => {
                        if (option.value === value_str) {
                            if (option.deselectOthers) {
                                deselect = true;
                            }
                        }
                    });
                }
            }
            return deselect;
        };
        switch (question.questionType) {
            case "radio":
                return question.options.map((option, i) => (_jsx(RadioButton, { value: option.value, checked: quizAnswers[question.questionName] || [], setValue: () => updateQuizAnswers([option.value], question.questionName), text: option.text, iconRaw: option.iconRaw, isFreeForm: option.free_form, setFreeFormValue: (value) => setFreeFormValue({ ...freeFormValues, [question.questionName]: value }), freeFormValue: freeFormValues[question.questionName] || "", labelFor: option.value + question.questionName }, option.value + question.questionName)));
            case "slider":
                return (_jsx(SliderComponent, { options: question.options, setValue: (value) => updateQuizAnswers(value, question.questionName), answer: quizAnswers[question.questionName] || [] }));
            case "checkbox":
                return question.options.map((option, i) => (_jsx(CheckboxButton, { value: option.value, text: option.text, setValue: (value, value2) => updateCheckboxAnswers(value, value2, question.questionName), answers: quizAnswers[question.questionName] || [], deselect: option.deselect, iconRaw: option.iconRaw, stopper: question.maxOptions, deselectOtherFlag: checkIfSelectedValueIsDeselectOther(quizAnswers[question.questionName]), setFlag: () => { }, deselectOther: option.deselectOthers, isFreeForm: option.free_form, setFreeFormValue: (value) => setFreeFormValue({ ...freeFormValues, [question.questionName]: value }), freeFormValue: freeFormValues[question.questionName] || "", labelFor: option.value + question.questionName }, option.value + i.toString())));
            case "hardcode":
                if (question.questionName === "heightAndWeight") {
                    return (_jsx(HeightAndWeightComponent, { setValue: (value) => updateQuizAnswers(value, question.questionName), prevAnswer: question.userAnswer, metrics: false, setMetrics: () => { }, hideMetrics: true }));
                }
                if (question.questionName === "goalWeight") {
                    return (_jsx(GoalWeight, { setValue: (value) => updateQuizAnswers(value, question.questionName), prevAnswer: question.userAnswer, metrics: false, setMetrics: () => { }, hideMetrics: true }));
                }
                break;
            default:
                return _jsx(_Fragment, {});
        }
    };
    return {
        quizData,
        quizAnswers,
        openDrawer,
        toggleDrawer,
        loading,
        updateQuizData,
        setQuizAnswers,
        getUIElement,
        toggleNotAnsweredQuestionsDrawer,
        openNotAnsweredQuestionsDrawer,
        notAnsweredQuestions,
        showAnimation,
    };
};
